import clsx from 'clsx';
import { ActiveSort, SortDirection, TableProps, useTableProps } from './tableTypes';
import TableHeader from './TableHeader';
import { useReducer, ReactNode } from 'react';

const useTable = <T,>({ initialSortKey }: useTableProps<T>) => {
    const [activeSort, setSort] = useReducer<
        (activeSort: ActiveSort<keyof T>, key: keyof T) => ActiveSort<keyof T>
    >(
        (prev, key) =>
            prev.sortKey === key
                ? {
                      ...prev,
                      direction:
                          prev.direction === SortDirection.ASC
                              ? SortDirection.DESC
                              : SortDirection.ASC,
                  }
                : { sortKey: key, direction: SortDirection.DESC },
        {
            direction: SortDirection.DESC,
            sortKey: initialSortKey,
        }
    );

    const Table = ({ children, className }: TableProps) => (
        <div className={clsx('table', className)}>{children}</div>
    );

    Table.Header = ({
        children,
        withSort,
        sortKey,
    }: {
        children: ReactNode;
        withSort?: boolean;
        sortKey?: keyof T;
    }) =>
        TableHeader<T>({
            children,
            withSort,
            sortKey,
            setSort,
        });

    return { Table, activeSort };
};

export default useTable;
